import { PageHeader, Button } from "antd";
import { useMoralis } from "react-moralis";
import close_button from "../images/close_buttons.svg";
import logo from "../images/logo.svg";
import "./Header.css";

const Header = () => {
  const { authenticate, account } = useMoralis();
  return (
    <div className="header-wrapper">
      <img src={close_button} alt="close" className="closebutton__button" />
      <img src={logo} alt="close" className="header__logo" />
      {/* Page header is basically the metamask button only */}
      <PageHeader
        extra={[
          <Button
            className="metamask_button"
            key="1"
            type="primary"
            onClick={() => authenticate()}
          >
            {account ? (
              <span>{account.slice(0, 5)}...</span>
            ) : (
              <span>Login with Metamask</span>
            )}
          </Button>,
        ]}
      ></PageHeader>
    </div>
  );
};

export default Header;
